const OrigemPedidoEnum = Object.freeze({
  PDV: 1,
  Site: 2,
  AppGarcon: 3,
  RoboIA: 4,
});

const getOrigemPedidoString = (origemPedido) => {
  if (origemPedido == null) return '-';
  if (typeof origemPedido === 'string') return origemPedido;

  if (typeof origemPedido === 'object') {
    return origemPedido.descricao || origemPedido.nome || '-';
  }

  if (origemPedido === OrigemPedidoEnum.PDV) return 'PDV';
  if (origemPedido === OrigemPedidoEnum.Site) return 'Site';
  if (origemPedido === OrigemPedidoEnum.AppGarcon) return 'App Garcom';
  if (origemPedido === OrigemPedidoEnum.RoboIA) return 'Robô IA';

  return String(origemPedido);
};

export { getOrigemPedidoString };
export default OrigemPedidoEnum;
